"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Return the range of buttons to be centrally displayed in the Paginator
 * @param breakpoint - Values match MatchMediaProps['breakpoint']
 */
function getRange(breakpoint) {
  if (breakpoint === 'sm') {
    return 3;
  }
  return 5;
}
var _default = getRange;
exports["default"] = _default;